import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
const i18n = i18nFilter();
const TOP_WEBSITES_DEFAULT_DURATION = "1m";

export const getUrlForTableRecord = (row) => {
    const { Domain } = row;
    const { webSource, country } = proNavigator.getApiParams();
    const toState = "digitalsuite_website_websiteperformance";
    const navigationParams = {
        key: Domain,
        country,
        webSource,
        duration: TOP_WEBSITES_DEFAULT_DURATION,
        isWWW: "*",
    };
    const innerLink = proNavigator.href(toState, navigationParams);
    return innerLink;
};

export const getTableOptions = () => {
    return {
        hideBorders: false,
        hideRowsBorders: false,
        hideHeaderBorders: true,
        disableSelection: true,
        tableType: "swTable--simple",
        noDataTitle: i18n("global.nodata.notavilable"),
        noDataSubtitle: i18n("global.nodata.notavilable.subtitle"),
    };
};
